export var IdActionButtonPriority;
(function (IdActionButtonPriority) {
    IdActionButtonPriority[IdActionButtonPriority["WebExclusivePackage"] = 0] = "WebExclusivePackage";
    IdActionButtonPriority[IdActionButtonPriority["WebOnlyOffer"] = 1] = "WebOnlyOffer";
    IdActionButtonPriority[IdActionButtonPriority["PIBirthdayGift"] = 2] = "PIBirthdayGift";
    IdActionButtonPriority[IdActionButtonPriority["PISkyGift"] = 3] = "PISkyGift";
    IdActionButtonPriority[IdActionButtonPriority["PIWelcomeBack"] = 4] = "PIWelcomeBack";
    IdActionButtonPriority[IdActionButtonPriority["GoldGrowthPackageAvailable"] = 5] = "GoldGrowthPackageAvailable";
    IdActionButtonPriority[IdActionButtonPriority["PIPlayerLeagueReward"] = 6] = "PIPlayerLeagueReward";
    IdActionButtonPriority[IdActionButtonPriority["PIPlayerLeagueRanking"] = 7] = "PIPlayerLeagueRanking";
    IdActionButtonPriority[IdActionButtonPriority["PICoopLeagueReward"] = 8] = "PICoopLeagueReward";
    IdActionButtonPriority[IdActionButtonPriority["PICoopLeagueRanking"] = 9] = "PICoopLeagueRanking";
    IdActionButtonPriority[IdActionButtonPriority["PICollectLeagueReward"] = 10] = "PICollectLeagueReward";
    IdActionButtonPriority[IdActionButtonPriority["PICollectLeagueRanking"] = 11] = "PICollectLeagueRanking";
    IdActionButtonPriority[IdActionButtonPriority["PromoteLeagueLevel"] = 12] = "PromoteLeagueLevel";
    IdActionButtonPriority[IdActionButtonPriority["DemoteLeagueLevel"] = 13] = "DemoteLeagueLevel";
    IdActionButtonPriority[IdActionButtonPriority["ExpansionDiscount"] = 14] = "ExpansionDiscount";
    IdActionButtonPriority[IdActionButtonPriority["ExternalBarnDiscount"] = 15] = "ExternalBarnDiscount";
    IdActionButtonPriority[IdActionButtonPriority["Blog"] = 16] = "Blog";
    IdActionButtonPriority[IdActionButtonPriority["PISystem"] = 17] = "PISystem";
    IdActionButtonPriority[IdActionButtonPriority["PICafeGift"] = 18] = "PICafeGift";
    IdActionButtonPriority[IdActionButtonPriority["CoopLevelUp"] = 19] = "CoopLevelUp";
    IdActionButtonPriority[IdActionButtonPriority["PlayerLeagueStart"] = 20] = "PlayerLeagueStart";
    IdActionButtonPriority[IdActionButtonPriority["CoopLeagueStart"] = 21] = "CoopLeagueStart";
    IdActionButtonPriority[IdActionButtonPriority["ThemedEvents"] = 22] = "ThemedEvents";
    IdActionButtonPriority[IdActionButtonPriority["WaterTower"] = 23] = "WaterTower";
    IdActionButtonPriority[IdActionButtonPriority["Dog"] = 24] = "Dog";
    IdActionButtonPriority[IdActionButtonPriority["ProjectFinished"] = 25] = "ProjectFinished";
    IdActionButtonPriority[IdActionButtonPriority["PISatisfaction"] = 26] = "PISatisfaction";
    IdActionButtonPriority[IdActionButtonPriority["PIFriendGift"] = 27] = "PIFriendGift";
    IdActionButtonPriority[IdActionButtonPriority["PIPurchasePointsReward"] = 28] = "PIPurchasePointsReward";
    IdActionButtonPriority[IdActionButtonPriority["CoopInvitation"] = 29] = "CoopInvitation";
    IdActionButtonPriority[IdActionButtonPriority["Trader"] = 30] = "Trader";
    IdActionButtonPriority[IdActionButtonPriority["PremiumHouseDiscount"] = 31] = "PremiumHouseDiscount";
    IdActionButtonPriority[IdActionButtonPriority["PremiumAcreDiscount"] = 32] = "PremiumAcreDiscount";
    IdActionButtonPriority[IdActionButtonPriority["PrimeTime"] = 33] = "PrimeTime";
    IdActionButtonPriority[IdActionButtonPriority["PromoteMobile"] = 34] = "PromoteMobile";
    IdActionButtonPriority[IdActionButtonPriority["PI_AnniversaryGift"] = 35] = "PI_AnniversaryGift";
})(IdActionButtonPriority || (IdActionButtonPriority = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/hud-action-button/IdActionButtonPriority.ts
// module id = 2289
// module chunks = 3